module.exports = __webpack_public_path__ + "../resources/img/bg_boxlst.b509c1c3.png";